var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useDeleteStudioModuleFieldMutation, useGetModuleFieldBuilderQuery, useGetModuleFieldTypeQuery, useSaveStudioModuleFieldMutation, } from "@/store/api";
import { LoaderImage } from "@/utils/loader";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FieldType from "./fieldType";
import { usePopup } from "@/hooks/layout";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
export default function EditField(_a) {
    var _this = this;
    var onFieldAction = _a.onFieldAction;
    var location = useLocation();
    var _b = useParams(), packagesName = _b.packagesName, moduleName = _b.moduleName, type = _b.type, action = _b.action, fieldName = _b.fieldName;
    var t = useTranslation(["common", "DynamicFields"]).t;
    var moduleField = useGetModuleFieldBuilderQuery({
        moduleName: moduleName,
        params: {
            package: packagesName,
            module: moduleName,
            fieldname: fieldName,
            lang: "en_us",
        },
    }).data;
    var typeField = useGetModuleFieldTypeQuery({
        moduleName: moduleName,
        params: {
            package: packagesName,
        },
    }).data;
    var _c = useState([] || ""), fieldType = _c[0], setFieldType = _c[1];
    var _d = useState({}), fieldTypes = _d[0], setFieldTypes = _d[1];
    var _e = useState({}), editedField = _e[0], setEditedField = _e[1];
    var _f = useState(true), isUpdate = _f[0], setIsUpdate = _f[1];
    var _g = useState(""), nameHasError = _g[0], setNameHasError = _g[1];
    var _h = useState(false), showLoader = _h[0], setShowLoader = _h[1];
    //Gestion type field
    var _j = useState("TextField"), typeValueField = _j[0], setTypeValueField = _j[1];
    var mbRoot = "/modules/ModuleBuilder";
    var navigate = useNavigate();
    useEffect(function () {
        if (fieldName) {
            if (fieldName === "new") {
                setIsUpdate(false);
            }
        }
    }, [fieldName]);
    var dataFieldDefs = useMemo(function () {
        if (!moduleField) {
            return {};
        }
        return moduleField.data.fieldDefs;
    }, [moduleField]);
    var modStrings = useMemo(function () {
        if (!moduleField) {
            return {};
        }
        return moduleField.data.modStrings;
    }, [moduleField]);
    var dataFieldTypes = useMemo(function () {
        if (!typeField) {
            return {};
        }
        return typeField.data.field_types;
    }, [typeField]);
    useEffect(function () {
        try {
            if (dataFieldDefs) {
                var updatedFieldDefs = __assign(__assign({}, dataFieldDefs), { labelValue: (dataFieldDefs &&
                        dataFieldDefs.vname &&
                        modStrings[dataFieldDefs.vname]) ||
                        "" });
                setEditedField(updatedFieldDefs);
                var matchedFieldType = (dataFieldDefs === null || dataFieldDefs === void 0 ? void 0 : dataFieldDefs.type) === "datetime"
                    ? fieldTypes["datetimecombo"]
                    : fieldTypes[dataFieldDefs.type];
                matchedFieldType && setTypeValueField(matchedFieldType);
            }
            else {
                console.error("Field data not found");
            }
        }
        catch (error) {
            console.error("Error loading field:", error);
        }
    }, [dataFieldDefs, fieldTypes, modStrings]);
    useEffect(function () {
        dataFieldTypes && setFieldTypes(dataFieldTypes);
    }, [dataFieldTypes]);
    var isCustomField = (editedField && editedField.custom_module === "") ||
        (editedField && editedField.custom_module === undefined)
        ? false
        : true;
    var _k = useSaveStudioModuleFieldMutation(), saveFieldMutation = _k[0], _l = _k[1], saveData = _l.data, tokenAccessError = _l.error;
    var _m = useState(), errInput = _m[0], setErrInput = _m[1];
    var handleValidation = function (error) {
        setErrInput(error);
    };
    var saveField = function () { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            setShowLoader(true);
            try {
                if (editedField.name === "") {
                    setShowLoader(false);
                    setNameHasError("Field Name empty");
                    navigate("".concat(location.pathname));
                }
                else {
                    setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                        var response, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, saveFieldMutation({
                                        moduleName: moduleName,
                                        body: {
                                            package: packagesName,
                                            isUpdate: false,
                                            settings: editedField,
                                            isNewField: !isUpdate,
                                            lang: "en_us",
                                        },
                                    }).unwrap()];
                                case 1:
                                    response = _a.sent();
                                    setShowLoader(false);
                                    result = response.data || {};
                                    if (result.error === "exist") {
                                        toast.error("Field not saved");
                                        if (editedField.name === "") {
                                            setNameHasError("Field name empty");
                                        }
                                        else {
                                            setNameHasError(result.message);
                                        }
                                    }
                                    else {
                                        toast.success("Field saved");
                                        if (!isUpdate) {
                                            onFieldAction();
                                            navigate("".concat(mbRoot, "/studio/packages/").concat(packagesName, "/").concat(moduleName, "/fields"));
                                        }
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); }, 500);
                }
            }
            catch (error) {
                toast.error("Field not saved");
            }
            return [2 /*return*/];
        });
    }); };
    var deleteFieldMutation = useDeleteStudioModuleFieldMutation()[0];
    var _o = usePopup(), showPopup = _o.showPopup, closePopup = _o.closePopup;
    var deleteField = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setShowLoader(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteFieldMutation({
                            moduleName: moduleName,
                            fieldName: fieldName,
                            body: {
                                settings: editedField,
                                packageName: packagesName,
                            },
                        }).unwrap()];
                case 2:
                    _a.sent();
                    setShowLoader(false);
                    cancelField();
                    onFieldAction();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setShowLoader(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var cancelField = function () {
        navigate("".concat(mbRoot, "/studio/packages/").concat(packagesName, "/").concat(moduleName, "/fields"));
    };
    if (!moduleField || !typeField || showLoader) {
        return _jsx(LoaderImage, {});
    }
    var handleSelectType = function (event) {
        var _a;
        setTypeValueField(event.target.value);
        var typevalue = (_a = Object.entries(dataFieldTypes).find(function (_a) {
            var key = _a[0], val = _a[1];
            return val === (event === null || event === void 0 ? void 0 : event.target.value);
        })) === null || _a === void 0 ? void 0 : _a[0];
        setEditedField(function (prevEditedField) { return (__assign(__assign({}, prevEditedField), { type: typevalue })); });
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsx("button", __assign({ className: "button primary text-white rounded-sm mx-1  px-2", onClick: saveField }, { children: t("app.LBL_SAVE_BUTTON_LABEL", { ns: "common" }) })), isCustomField && (_jsx("button", __assign({ className: "button danger text-white rounded-sm mx-1  px-2 ", onClick: deleteField }, { children: t("app.LBL_DELETE", { ns: "common" }) }))), _jsx("button", __assign({ className: "button secondary text-white rounded-sm mx-1  px-2", onClick: cancelField }, { children: t("app.LBL_CANCEL", { ns: "common" }) }))] }), _jsx("div", { className: "columns" }), _jsx("div", __assign({ className: "content flex flex-col p-4 max-h-[50vh] overflow-y-scroll w-full" }, { children: _jsx("table", __assign({ className: " text-gray-500" }, { children: _jsxs("tbody", { children: [_jsxs("tr", __assign({ className: "border-gray-300 border-b-2" }, { children: [_jsx("td", { children: _jsx("label", { children: t("LBL_DATA_TYPE", { ns: "DynamicFields" }) }) }), _jsx("td", { children: isUpdate ? (_jsx("label", __assign({ className: "pr-2" }, { children: typeValueField }))) : (_jsx("div", { children: _jsx("select", __assign({ name: "dataType", onChange: handleSelectType, value: typeValueField }, { children: Object.entries(dataFieldTypes).map(function (_a) {
                                                    var key = _a[0], value = _a[1];
                                                    return (_jsx("option", __assign({ value: value }, { children: value }), key));
                                                }) })) })) })] })), _jsx(FieldType, { type: typeValueField, settings: editedField, error: nameHasError, errorInputValue: errInput, updated: isUpdate, updateSettings: function (name, value) {
                                    setEditedField(function (prevValue) {
                                        var _a;
                                        return (__assign(__assign({}, prevValue), (_a = {}, _a[name] = value, _a)));
                                    });
                                } })] }) })) }))] }));
}
